import { CENTRAL_REPROCESSAMENTO_TAMANHO_ENUM } from '@/constants/central-reprocessamento/ConstantCentralReprocessamentoTamanho';
import { CENTRAL_REPROCESSAMENTO_TIPOS_ENUM } from '@/constants/central-reprocessamento/ConstantCentralReprocessamentoTipos';
import BaseModel from '@/model/BaseModel';

/**
 * @typedef CentralReprocessamentoCriarRequestDTO
 * @property {CENTRAL_REPROCESSAMENTO_TIPOS_ENUM} tipo
 * @property {CENTRAL_REPROCESSAMENTO_TAMANHO_ENUM} tamanho
 * @property {string[]} nrinsc
 */
export class ModelCentralReprocessamentoFormulario extends BaseModel {
  constructor() {
    super();
    this.tipo = null;
    this.tamanho = CENTRAL_REPROCESSAMENTO_TAMANHO_ENUM.PEQUENO.getValue();
    this.nrinsc = [];
  }

  /** @param {CentralReprocessamentoCriarRequestDTO} dto */
  static fromObject(dto) {
    const instance = new ModelCentralReprocessamentoFormulario();
    instance.tipo = CENTRAL_REPROCESSAMENTO_TIPOS_ENUM.get(dto.tipo).getValue();
    instance.tamanho = CENTRAL_REPROCESSAMENTO_TAMANHO_ENUM.get(dto.tamanho).getValue();
    instance.nrinsc = dto.nrinsc;
    return instance;
  }
}
